export default {
  state: {
    lat: "",
    lng: "",
    addr: ""
  },
  mutations: {
    //显式的更改state里的数据
    setGps(state, payload) {
      for (let i in payload) {
        for (let j in state) {
          if (i === j) {
            state[j] = payload[i];
          }
        }
      }
    }
  },
  getters: {
    getPosition(context) {
      return {
        lat: context.lat,
        lng: context.lng,
        addr: context.addr
      };
    }
  },
  actions: {
    /*
    baiduPosition(context) {
      try {
        let geolocation = new BMap.Geolocation();
        geolocation.enableSDKLocation();
        geolocation.getCurrentPosition(function(r) {
          console.log('定位成功', r, this.getStatus())
          if (r.latitude && r.longitude) {
            let addComp = r.address;
            console.log(addComp)
            let positon = {
              lng: r.point.lng,
              lat: r.point.lat,
              addr: (addComp.province || '') + "" + (addComp.city || '') + "" + (addComp.district || '') + "" + (addComp.street || '') +
                "" + (addComp.streetNumber || '')
            }
            context.commit('setGps', positon)
            console.log('您的位置：' + r.point.lng + ',' + r.point.lat + '  ' + positon.addr);
          } else if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            let geoc = new BMap.Geocoder();
            geoc.getLocation(r.point, function(rs) {
              console.log('geoc getLocation', rs)
              let addComp = rs.addressComponents;
              let positon = {
                lng: r.point.lng,
                lat: r.point.lat,
                addr: addComp.province + "" + addComp.city + "" + addComp.district + "" + addComp.street +
                  "" + addComp.streetNumber
              }
              context.commit('setGps', positon)
              console.log('您的位置：' + r.point.lng + ',' + r.point.lat + '  ' + positon.addr);
            });
          } else {
            console.log('gps status error', r, this.getStatus(), BMAP_STATUS_SUCCESS)
          }
        }, function(e) {
          console.log('定位失败', e)
        },{
          enableHighAccuracy: true,    // High accuracy mode
          timeout: 150000,              // Timeout in milliseconds
          maximumAge: 300000           // Cache location for 5 minutes
        })
      } catch (e) {
        console.log('error', e)
      }
    }*/
    baiduPosition(context) {
      AMap.plugin("AMap.Geolocation", function() {
        let geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: false,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000,
          // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
          buttonOffset: new AMap.Pixel(10, 20),
          //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
          zoomToAccuracy: true,
          //  定位按钮的排放位置,  RB表示右下
          buttonPosition: "RB"
        });

        geolocation.getCurrentPosition();
        AMap.event.addListener(geolocation, "complete", onComplete);
        AMap.event.addListener(geolocation, "error", onError);

        function onComplete(data) {
          AMap.plugin("AMap.Geocoder", function() {
            let geocoder = new AMap.Geocoder({});
            let lnglat = [data.position.lng, data.position.lat];
            geocoder.getAddress(lnglat, function(status, result) {
              if (status === "complete" && result.info === "OK") {
                const {
                  province,
                  city,
                  district,
                  street,
                  streetNumber
                } = result.regeocode.addressComponent;
                let positon = {
                  lng: data.position.lng,
                  lat: data.position.lat,
                  addr:
                    province +
                    "" +
                    city +
                    "" +
                    district +
                    "" +
                    street +
                    "" +
                    streetNumber //  result.regeocode.formattedAddress
                };
                context.commit("setGps", positon);
                console.log(
                  `🚀 ~ file: gps.js:106 ~ geocoder.getAddress ~ positon.result:`,
                  result
                );
              }
            });
          });
        }

        function onError(data) {
          // 定位出错
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/gps.js